import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { SearchSchema } from './-zod-schema';

export const Route = createFileRoute(
  '/_staff/people/_list/operation-activity/',
)({
  validateSearch: zodValidator(SearchSchema),
});
